export const FEATURES = {
    KANBAN: 'kanban' as const,
    CLOSE_REASON: 'closeReason' as const,
    CAMPANHAS: 'campanhas' as const,
    FOLLOW_UP: 'followUp' as const
};
